import { render } from "./RiContattiUtenti.vue?vue&type=template&id=489bf92a&scoped=true"
import script from "./RiContattiUtenti.vue?vue&type=script&lang=js"
export * from "./RiContattiUtenti.vue?vue&type=script&lang=js"

import "./RiContattiUtenti.vue?vue&type=style&index=0&id=489bf92a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489bf92a"]])

export default __exports__